<template>
  <section class="user-input">
    <button @click="connectWallet()" className="WalletButton" v-if='!isWalletConnected'> <strong>CONNECT WALLET</strong></button>
    <button className="ConectedWallet" v-if='isWalletConnected'> <strong>CONNECTED: {{concatted}}</strong></button>
    <div class="container">
          <PriceInput
            :onMint='onMint'
            :price='this.price'
            :totalRemaining='this.remaining'
            :minter='0'
          />
        </div>
        
        <div className="ending">
          
        </div>
        
  </section>
</template>

<script>
import PriceInput from '@/components/PriceInput.vue';
import Web3 from "web3";
import WL from 'walletlink';
import Portis from '@portis/web3';
import cbSVG from '../assets/coinbase-wallet.svg';
import WalletConnectProvider from "@walletconnect/web3-provider";
import axios from 'axios';

export default {
  components: {
    PriceInput
  },
  data () {
    return {
      concatenatedAddress: "",
      isWalletConnected: false,
      account: "",
      provider: "",
      chainID: 1,   
      price: '---',
      concatted: "",
      remaining: "---",
      contract: "",
      contractaddress: '0xE938E4B8Ce51eeAcc4c4454a08B59f70eE9C2293',  
      supply: '---', 
      onWL: false,
      pubSaleActive: false,
      clear: true,
      ismeta: true
    } 
  },
  mounted() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", this.onAccountsChange);
    }
  },
  methods: {
    activateReadMore(){
        this.readMoreActivated = true;
    },
    async setProvider(){
      const chainId = this.chainID;
      const providerOptions = {
          'custom-walletlink': {
              display: {
                  logo: cbSVG,
                  name: 'Coinbase',
                  description: 'Use WalletLink to connect to Coinbase',
              },
              options: {
                  appName: 'AstroMojis',
                  networkUrl: 'https://mainnet.infura.io/v3/955da6b335b248d688adcce37bc1f261',
                  chainId,
              },
              package: WL,
              connector: async (_, options) => {
                  const { appName, networkUrl, chainId } = options
                  const walletLink = new WL({
                      appName
                  });
                  const provider = walletLink.makeWeb3Provider(networkUrl, chainId);
                  await provider.enable();
                  return provider;
              },
          },
          portis: {
              package: Portis,
              options: {
                  id: "b04705fc-a328-4d74-a8c5-c6ef90d242c8",
                  chainId
              }
          },
          walletconnect: {
            package: WalletConnectProvider, 
            options: {
              infuraId: "0421d5ecf8894580a7bbfc5c1d3be0c9" 
            }
          }

      };
      const Web3Modal = require('web3modal')
      const web3Modal = new Web3Modal.default({
          theme: "dark",
          network: "mainnet",
          providerOptions
      });
      
      var provider = ''
      console.log("*:",this.clear)
      await web3Modal.clearCachedProvider();
      provider = await web3Modal.connect()
      const web3 = new Web3(provider);
      this.provider = web3;
      if (this.provider.currentProvider.isMetaMask != true){
        this.ismeta = false
      }else{
        console.log("Using metamask")
      }
    },
    onAccountsChange(accounts) {
      if (!this.provider) {
        this.isWalletConnected = false;
        return
      } else {
        this.account = accounts[0];
        this.isWalletConnected = true;
        this.concatted = this.account.slice(0,4) + '...' + this.account.slice(this.account.length-4,this.account.length-1)
      }
    },

    /**
     * @param {Object} error
     */
    onWalletConnectError(error) {
      if (error.code === 4001) {
        console.log("User has rejected the connection request.");
      } else {
        console.error(error.message);
      }
    },
    async connectWallet() {
      if (this.clear){
        await this.setProvider()
      }
      const netID = await this.provider.eth.net.getId()
      if (netID != this.chainID){
        this.$store.commit('SEND_TOAST_MESSAGE', {
            message: "You are not on Ethereum Mainnet, please change your network",
            type: 'warning'
          });
          return;
      }
      const accounts = await this.provider.eth.getAccounts()
      this.account = accounts[0];
      this.isWalletConnected = true;
      this.concatted = this.account.slice(0,4) + '...' + this.account.slice(this.account.length-4,this.account.length-1)
      const abi = require('../../build/contracts/AstroMojis.json')
      const contract = new this.provider.eth.Contract(
        abi.abi,
        this.contractaddress
      );
      this.contract = contract;
      const minted = await contract.methods.totalSupply().call()
      const publicSaleOn = await this.contract.methods.SaleActive().call()
        console.log(publicSaleOn)
      
      if (publicSaleOn) {
        this.onWL = false;
        const weip = await this.contract.methods.MintPrice().call()
        this.price = this.provider.utils.fromWei(weip.toString(), 'ether')
        this.pubSaleActive = true;
        this.supply = await this.contract.methods.Supply().call()
        this.remaining = this.supply - minted
        return
      }else {
        this.supply = '---'
      }
      
    },

    async onMint({quantity, totalEth, price, minter}) {
      if (!this.isWalletConnected){
        this.$store.commit('SEND_TOAST_MESSAGE', {
            message: "Please Connect Wallet",
            type: 'error'
          });
          return;
      }
      const bal = await this.provider.eth.getBalance(this.account)
      console.log("bblanace",this.provider.utils.fromWei(bal,'ether'))
      if (Number(this.provider.utils.fromWei(bal,'ether')) < 0.0777*Number(quantity)){
        this.$store.commit('SEND_TOAST_MESSAGE', {
            message: "Mint is 0.0777 Eth each. You dont have enough ethereum in your account",
            type: 'error'
          });
          return;
      }
      this.clear = false;
      await this.connectWallet()
      console.log(totalEth,price,minter)
      if (this.remaining == 0){
        this.$store.commit('SEND_TOAST_MESSAGE', {
            message: "We are SOLD OUT of phase 1!",
            type: 'info'
          });
          return;
      }
      if(quantity>20){
        this.$store.commit('SEND_TOAST_MESSAGE', {
            message: "Only 20 NFTs per transaction allowed!",
            type: 'error'
          });
          return;
      }
      if (!(this.remaining - quantity >= 0) && (this.price!= '---')){
        this.$store.commit('SEND_TOAST_MESSAGE', {
            message: "Your mint would exceed the supply",
            type: 'error'
          });
          return;
      }
       if (this.pubSaleActive){
        try{
          // if (this.ismeta){
          const gweiWEb3js = Number(await this.provider.eth.getGasPrice())/1000000000
          var g;
          const GasTracker = await axios.get('https://ethgasstation.info/json/ethgasAPI.json')
          const gweiGT = Number(GasTracker.data.average)
          if (gweiGT> gweiWEb3js){
            g = gweiWEb3js;
          } else {
            g = gweiGT;
          }
          if (g> 300){
            g = 300;
          }
          g = g*1000000000
          g = Math.floor(g)
          var GasLimit = await this.contract.methods.mint(quantity).estimateGas({gas: g, from:this.account, value:this.provider.utils.toWei((quantity*this.price).toString())})
          GasLimit = Math.floor(GasLimit*1.1);
          await this.contract.methods.mint(quantity).send({from:this.account, value:this.provider.utils.toWei((quantity*this.price).toString(), 'ether'),gasPrice:String(g), gas:GasLimit})
          this.$store.commit('SEND_TOAST_MESSAGE', {
              message: "SUCCESSFUL MINT",
              type: 'success'
            });
            // return;
          // /*}*/ else {
          //   await this.contract.methods.mint(quantity).send({from:this.account, value:this.provider.utils.toWei((quantity*this.price).toString(), 'ether')})
          // }
        } catch (err){
          console.log(err)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '../styles/mixins.scss';



.container {
  width: 375px;
}
.user-input {
  padding: inherit;
  height: 100%;
  width: auto;

  .bg-img {
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
    opacity: 0.4;
    height:100%;
  }
}
@media (max-height: 775px) {
    .user-input {
    height: 100%;
    width: auto;
    padding: 0 0 100px;
    background-color: black;
}
}
.featured-collection {
  margin: 0 0 120px;
  display: flex;
  flex-flow: row nowrap;

  @include breakpoint(tablet) {
    margin-bottom: 80px;
    flex-flow: column wrap;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  .border-radius {
    width: 100%;
    height: inherit;
    top: 10px;
    position: absolute;
    border: 2px solid white;
    border-radius: 8px;
    z-index: 1;

    @include breakpoint(tablet) {
      border-width: 1px;
      top: 3px;
    }
  }

  &.normal {
    .border-radius {
      left: -10px;
      @include breakpoint(tablet) {
        left: -3px;
      }
    }
    
    .col {
      &:first-child {
        margin-right: 80px;

        @include breakpoint(tablet) {
          margin-right: initial;
        }
      }

      &:last-child {
        margin-left: 20px;

        @include breakpoint(tablet) {
          margin-left: initial;
        }
      }
    }
  }

  &.reverse {
    flex-flow: row-reverse nowrap;

    @include breakpoint(tablet) {
      flex-flow: column wrap;
    }

    .border-radius {
      right: -10px;

      @include breakpoint(mobile) {
        right: initial; left: -3px;
      }
    }

    .col {
      &:first-child {
        margin-left: 20px;

        @include breakpoint(tablet) {
          margin-left: initial;
        }
      }

      &:last-child {
        margin-right: 80px;

        @include breakpoint(tablet) {
          margin-right: initial;
        }
      }
    }
  }
}
.ViewContract {
  color: #8688C6;
}
.featured-collection {
  .featured-text {
    width: 50%;

    @include breakpoint(tablet) {
      width: 100%;
      margin-bottom: 40px;
    }

    .featured-meta {
      width: 100%;
      margin: 0 0 24px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;

      h4 {
        margin: 0;
      }
    }

    .portrait {
      width: 72px;
      height: 72px;
      margin: 0 16px 0 0;

      img {
        width: inherit;
        height: inherit;
        object-fit: cover;
        object-position: 50% 50%;
        border-radius: 50px;
      }
    }
  }

  .featured-image {
    width: 50%;

    @include breakpoint(tablet) {
      width: 100%;
    }
  
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 50% 50%;
      border-radius: 8px;
      position: relative;
      z-index: 4;
    }
  }
}

.featured-collection {
  .featured-artwork {
    width: 100%;
    height: 500px;
    position: relative;
    z-index: 4;

    @include breakpoint(tablet) {
      height: 360px;
    }

    iframe {
      width: 100% !important;
      height: 100% !important;
      position: relative;
      border-radius: 8px;
      z-index: 4;
      object-fit: cover;
    }

    &.is-video {
      height: 400px;
      @include breakpoint(mobile) {
        height: 250px;
      }
    }
  }
}

.logo-company {
  width: 120px;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: 0 50%;
    border-radius: 8px;

    &:not(:first-child) {
      margin-left: 80px;
    }
  }
}

.contactview{ 
  position: flex;
  margin-top: 30px;
  padding: 0 60px;
}

.ending{
  background-image: black;
}
</style>